import React, { useEffect, useState } from "react";
import Select from "react-select";
import close from "../../assets/icons/close.svg";
import "../../assets/css/Modal.css";
import { reactSelectStyles } from "../../Utils/selectBoxStyle";
import { getData, Postdata, Postdataform } from "../../API/GlobalApi";
import OtpModal from "./DiscountOtpInput";
import FocusTrap from "focus-trap-react";
import { useFocusTrap } from "../../Utils/TabIndexingFocus";
import Notifier from "../../Utils/notify";
export const TransferTransactions = ({ isOpen, onClose, selectedTxnStats, getTransactionStats, getFeeReceivedData, getTransactions }) => {
    const [activeTab, setActiveTab] = useState("deposit");
 
    const [formData, setFormData] = useState({
        bankAccount: null,
        employees: null,
        cash: { amount: "" },
        cheque: {},  // stores files as cheque[transaction_id] = File
        dd: {},      // stores files as dd[transaction_id] = File
        remark: "",
    });


    const getRemittanceTitle = (type) => {
        switch (type) {
            case "Cash In Hands":
                return "Cash";
            case "No of demand draft":
                return "Demand Draft";
            case "No of cheque":
                return "Cheque";
            case "NEFT/RTGS/IMPS":
                return "NEFT/RTGS/IMPS";
            default:
                return type; // fallback
        }
    };





    const txnType = selectedTxnStats?.type || "";
    const handleChange = (type, transactionIdOrField, value) => {
        setFormData(prev => {
            // For remark
            if (type === "remark") return { ...prev, remark: value };

            // For bankAccount or employees
            if (type === "bankAccount" || type === "employees") {
                return { ...prev, [type]: value };
            }

            // For cheque or dd files per transaction
            return {
                ...prev,
                [type]: {
                    ...prev[type],
                    [transactionIdOrField]: value,  // transactionId = key
                },
            };
        });
    };



    const [otpModal, setOtpModal] = useState(false)
    const [transferSubmitResponse, setTransferSubmitResponse] = useState()


    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("remark", formData.remark || "");

            // 👉 Cash Deposit
            if (activeTab === "deposit" && txnType.includes("Cash")) {
                formDataToSend.append("bank_id", formData.bankAccount || "");
                
                formDataToSend.append(
                    "amount",
                    formData?.cash?.amount !== "" ? formData.cash.amount : selectedTxnStats?.numbers
                );
                 


                // formDataToSend.append(
                //     "amount",
                //     formData?.cash?.amount ?? selectedTxnStats?.numbers ?? 0
                // );

                if (formData.dd?.image) {
                    formDataToSend.append("deposit_slip", formData.dd.image);
                }


                // for (let pair of formDataToSend.entries()) console.log(pair[0], pair[1]);

                const response = await Postdataform("finance/cash-deposit/initiate/", formDataToSend);
 
                if (response?.status === 200 && !response?.error) {
                    Notifier.success(response?.message || "Cash deposit successful");
                    getTransactionStats();
                    getFeeReceivedData()
                    getTransactions()
                    resetForm();
                    onClose();
                } else {
                    Notifier.error(response?.error || "Failed to complete cash deposit");
                }
                return;
            }

            // 👉 Cash Transfer
            if (activeTab === "transfer" && txnType.includes("Cash")) {
                formDataToSend.append("transfered_to", formData.employees?.value || "");
                // formDataToSend.append("amount", selectedTxnStats?.numbers || 0);
                formDataToSend.append(
                    "amount",
                    formData?.cash?.amount !== "" ? formData.cash.amount : selectedTxnStats?.numbers
                );


                // for (let pair of formDataToSend.entries()) console.log(pair[0], pair[1]);

                const response = await Postdataform("finance/cash-transfer/initiate/", formDataToSend);

                if (response?.message || response?.status === 200) {
                    Notifier.success(
                        `Remittance initiated successfully. An OTP has been sent to ${formData.employees?.label} for verification.`
                    );
                    setTransferSubmitResponse({
                        otp: response?.otp,
                        selectedEmployee: formData.employees?.label,
                        cash_unique_id: response?.cash_unique_id,
                    });
                    setOtpModal(true);
                    getFeeReceivedData()
                    getTransactions()
                    resetForm();
                } else {
                    Notifier.error(response?.error || "Failed to complete cash transfer");
                }
                return;
            }

            // 👉 Cheque / DD Deposit (with images)
            if (activeTab === "deposit" && (txnType.toLowerCase().includes("cheque") || txnType.toLowerCase().includes("demand draft"))) {
                const cleanedTxnType = txnType.replace(/^No of /i, "").toLowerCase(); // 'cheque' or 'demand draft'
                const formDataChequeDD = new FormData();

                // Basic info
                formDataChequeDD.append("bank_id", formData.bankAccount || "");
                formDataChequeDD.append(
                    "instrument_type",
                    cleanedTxnType === "cheque" ? "Cheque" : "Demand Draft"
                );
                formDataChequeDD.append("remark", formData.remark || "");

                // Selected transactions
                const selectedTransactions = selectedTxnStats?.payment_details?.filter(dd =>
                    selectedRows.includes(dd.transaction_id)
                ) || [];

                // Transaction IDs comma-separated
                const transactionIdsStr = selectedTransactions.map(dd => dd.transaction_id).join(",");
                formDataChequeDD.append("transaction_ids", transactionIdsStr);

                // Attach files
                selectedTransactions.forEach(dd => {

                    // Use the correct state object
                    const fileMap = cleanedTxnType === "cheque" ? formData.cheque : formData.dd;

                    const file = fileMap?.[dd.transaction_id];

                    if (file instanceof File) {
                        const ext = file.name.split(".").pop() || "jpg";
                        const customFileName = `${dd.transaction_id}.${ext}`;
                        formDataChequeDD.append("files", file, customFileName);
                    } else {
                        console.warn(`❌ Missing file for transaction ID: ${dd.transaction_id}`);
                    }
                });

                // Debug

                // for (let pair of formDataChequeDD.entries()) {
                //     if (pair[1] instanceof File) console.log(pair[0], pair[1].name, pair[1].size);
                //     else console.log(pair[0], pair[1]);
                // }

                // Send request
                try {
                    const response = await Postdataform(
                        "finance/balance-deposit/initiate/",
                        formDataChequeDD
                    );

                    if (response?.message || response?.status === 200) {
                        Notifier.success(response?.message || "Cheque/DD deposit successful");
                        onClose();
                        getTransactionStats()
                        getFeeReceivedData()
                        getTransactions()
                        resetForm();
                        setSelectedRows([]);
                    } else {
                        Notifier.error(response?.error || "Failed to complete cheque/DD deposit");
                    }
                } catch (error) {
                    console.error("❌ API Error:", error);
                    Notifier.error(error?.message || "Unexpected error during cheque/DD deposit");
                }
                return;
            }

            // 👉 Cheque / DD Transfer (no images)
            if (activeTab === "transfer" && (txnType.includes("cheque") || txnType.includes("demand draft"))) {
                const payload = {
                    employee_id: formData.employees?.value || "",
                    remark: formData.remark || "",
                    transaction_ids: selectedTxnStats?.payment_details
                        ?.filter((dd) => selectedRows.includes(dd.transaction_id))
                        ?.map((dd) => dd.transaction_id) // keep as integer
                        ?.join(",") || "", // join into string
                    instrument_type: txnType.includes("cheque") ? "Cheque" : "Demand Draft",
                };



                const response = await Postdata("finance/balance-transfer/initiate/", payload);

                if (response?.message || response?.status === 200) {
                    Notifier.success(
                        `Remittance initiated successfully. An OTP has been sent to ${formData.employees?.label} for verification.`
                    );

                    setTransferSubmitResponse({
                        otp: response?.otp,
                        selectedEmployee: formData.employees?.label,
                        unique_id: response?.unique_id,
                    });
                    setOtpModal(true);

                    resetForm();
                    setSelectedRows([]);
                } else {
                    Notifier.error(response?.error || "Failed to complete cheque/DD transfer");
                }
                return;
            }

            // 👉 Fallback
            Notifier.error("Unsupported operation. Please check transaction type and tab.");
        } catch (error) {
            console.error("❌ API Error:", error);
            Notifier.error(error?.message || "Unexpected error occurred");
        } finally {
            setLoading(false); // always stop loader
        }

    };
    // ✅ Extracted reset logic into a helper
    const resetForm = () => {
        const defaultAcc = bankOptions.find(acc => acc.isDefault);

        setFormData({
            bankAccount: defaultAcc ? defaultAcc.value : null,
            employees: null,
            cash: { amount: "" },
            cheque: { date: "", image: null },
            dd: { date: "", image: null },
            remark: "",
        });
        setSelectedRows([]);
        setActiveTab("deposit");
    };


    const handleConfirmOtp = async (otpCode) => {
        if (!transferSubmitResponse) {
            Notifier.error("OTP is missing. Cannot verify OTP.");
            return;
        }

        try {
            let url = "";
            let payload = {};

            if (txnType.includes("Cash")) {
                // Cash OTP verification
                url = "finance/cash-transfer/verify-otp/";
                payload = {
                    cash_unique_id: transferSubmitResponse?.cash_unique_id,
                    otp: otpCode,
                };
            } else if (txnType.includes("cheque") || txnType.includes("demand draft")) {
                // Cheque/DD OTP verification
                url = "finance/balance-transfer/verify-otp/";
                payload = {
                    unique_id: transferSubmitResponse?.unique_id, // or the ID returned after initiating cheque/DD
                    otp: otpCode,
                };
            } else {
                Notifier.error("Unsupported operation for OTP verification.");
                return;
            }

            const response = await Postdata(url, payload);


            if (response?.error) {
                Notifier.error(response.error);
                return;
            }
            // Success
            Notifier.success("Transaction has been completed successfully.");
            getTransactionStats();
            getFeeReceivedData()
            getTransactions()
            setOtpModal(false);
            onClose();
        } catch (error) {
            console.error("Error verifying OTP:", error);
            Notifier.error(error?.message || "Failed to verify OTP");
        }
    };


    const handleCancelOtp = () => {
        onClose()
        getTransactionStats();
        getFeeReceivedData()
        getTransactions()
        setOtpModal(false);

    };

    const handlesResendOtpToAssignedPerson = async () => {
        try {
            let url = "";
            let payload = {};

            if (txnType.includes("Cash")) {
                // Cash resend OTP
                url = "finance/cash-transfer/resend-otp/";
                payload = { cash_unique_id: transferSubmitResponse?.cash_unique_id };
            } else if (txnType.includes("cheque") || txnType.includes("demand draft")) {
                // Cheque/DD resend OTP
                url = "finance/balance-transfer/resend-otp/"; // replace with actual endpoint
                payload = {
                    unique_id: transferSubmitResponse?.unique_id,
                };
            } else {
                Notifier.error("Unsupported operation for OTP resend.");
                return;
            }

            const response = await Postdata(url, payload);

            if (!response?.error) {
                // Update state for both Cash and Cheque/DD
                setTransferSubmitResponse((prev) => ({
                    ...prev,
                    otp: response?.otp,
                    selectedEmployee: formData.employees?.label,
                    cash_unique_id: txnType.includes("Cash") ? response?.cash_unique_id : prev?.cash_unique_id,
                    unique_id: prev?.unique_id,
                }));

                Notifier.success(response.message || "OTP resent successfully!");
            } else {
                Notifier.error(response.message || "Failed to resend OTP.");
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message || error?.message || "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };




    const [helpdeskperson, setHelpDeskPerson] = useState([]);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);




    const [bankOptions, setBankOptions] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [bankResponse, helpdeskResponse] = await Promise.all([
                    getData("finance/institution-bank-accounts/"),
                    getData("finance/course-fee-plans/authorized-employees/?type=balance-transfer"),
                ]);

                if (Array.isArray(bankResponse)) {
                    const mappedOptions = bankResponse.map((acc) => ({
                        value: acc.id,
                        label: `A/C: ${acc.account_number} - ${acc.account_holder_name} - ${acc.bank_name}`,
                        isDefault: acc.is_default || false, // 👈 keep track of default
                    }));

                    setBankOptions(mappedOptions);


                    const defaultAcc = mappedOptions.find((acc) => acc.isDefault);
                    if (defaultAcc) {
                        setFormData((prev) => ({
                            ...prev,
                            bankAccount: defaultAcc.value,
                        }));
                    }
                }

                setHelpDeskPerson(
                    helpdeskResponse?.authorized_employees?.map((emp) => ({
                        value: emp.id,
                        label: emp.name,
                    })) || []
                );
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);




    const [selectedRows, setSelectedRows] = useState([]);

    // ✅ Handle "Select All"
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(selectedTxnStats.payment_details.map((dd) => dd.transaction_id));
        } else {
            setSelectedRows([]);
        }
    };

    // ✅ Handle Individual Row Select
    const handleRowSelect = (transactionId) => {
        setSelectedRows((prev) =>
            prev.includes(transactionId)
                ? prev.filter((id) => id !== transactionId) // uncheck
                : [...prev, transactionId] // check
        );
    };

    // Reset when switching tabs
    useEffect(() => {
        const defaultAcc = bankOptions.find(acc => acc.isDefault);
        setFormData({
            bankAccount: defaultAcc ? defaultAcc.value : null,
            employees: null,
            cash: { amount: "" },
            cheque: { date: "", image: null },
            dd: { date: "", image: null },
        });
        setSelectedRows([]);
    }, [activeTab]);

    const handleClose = () => {
        // Find default account
        const defaultAcc = bankOptions.find(acc => acc.isDefault);


        // Reset states
        setActiveTab("deposit");
        setFormData({
            bankAccount: defaultAcc ? defaultAcc.value : null, // ✅ reset to default again
            employees: null,
            cash: { amount: "" },
            cheque: { date: "", image: null },
            dd: { date: "", image: null },
            remark: "",
        });
        setSelectedRows([]);

        // Call original onClose
        onClose();
    };

    const cleanedTxnType = txnType.replace(/^No of /i, "").toLowerCase(); // "cheque" or "demand draft"


    const renderFields = () => {
        if (txnType.includes("Cash")) {
            return (
                <>
                    {activeTab === "deposit" && (
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-labell">
                                    Select Bank Account<span className="astrisk">*</span>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <Select
                                    options={bankOptions}
                                    value={bankOptions.find((opt) => opt.value === formData.bankAccount)}
                                    onChange={(selected) =>
                                        setFormData((prev) => ({ ...prev, bankAccount: selected.value }))
                                    }
                                    placeholder="Choose Bank Account..."
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    styles={{
                                        ...reactSelectStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    tabSelectsValue={true}
                                />
                            </div>
                        </div>
                    )}

                    {activeTab === "transfer" && (
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-labell">
                                    Select Employee<span className="astrisk">*</span>
                                </label>
                            </div>

                            <div className="col-md-6">
                                <Select
                                    options={helpdeskperson} // ✅ dynamic employee list
                                    value={formData.employees}
                                    onChange={(selected) => handleChange("employees", null, selected)}
                                    styles={{
                                        ...reactSelectStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    placeholder="Select Employee..."
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    tabSelectsValue={true}
                                />

                            </div>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-labell">
                                Enter Amount<span className="astrisk">*</span>
                            </label>
                        </div>
                        <div className="col-md-6">

                            <input
                                type="number"
                                placeholder="Enter Amount"
                                className="form-control fm-modal"
                                defaultValue={selectedTxnStats?.numbers || ""}
                                onChange={(e) => handleChange("cash", "amount", e.target.value)}
                                style={{ width: "100%", marginTop: "10px" }}
                            />


                        </div>
                    </div>

                    {activeTab === "deposit" && (
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-labell">
                                    Upload Deposit slip<span className="astrisk">*</span>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="file"
                                    placeholder="Uplode deposit slip"
                                    accept="image/*"
                                    className="form-control fm-modal mt-2"
                                    style={{ width: "100%", marginTop: "10px" }}
                                    onChange={(e) => handleChange("dd", "image", e.target.files[0])}
                                />

                            </div>
                        </div>
                    )}

                    {/* 🆕 Remark field for both tabs */}
                    <div className="row mt-3">
                        <div className="col-md-4">
                            <label className="form-labell">Remark</label>
                        </div>
                        <div className="col-md-6">
                            <textarea
                                className="form-control fm-modal"
                                placeholder="Enter remark (optional)"
                                value={formData.remark}
                                onChange={(e) => handleChange("remark", null, e.target.value)}
                                rows={2}
                            />
                        </div>
                    </div>
                </>
            );
        }

        if (txnType.includes("cheque")) {
            return (
                <>      {activeTab === "deposit" && (
                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-labell">
                                Select Bank Account<span className="astrisk">*</span>
                            </label>
                        </div>
                        <div className="col-md-6">
                            <Select
                                options={bankOptions}
                                value={bankOptions.find((opt) => opt.value === formData.bankAccount)}
                                onChange={(selected) =>
                                    setFormData((prev) => ({ ...prev, bankAccount: selected.value }))
                                }
                                placeholder="Choose Bank Account..."
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                    ...reactSelectStyles,
                                    menuPortal: base => ({ ...base, zIndex: 99999999 })
                                }}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                tabSelectsValue={true}
                            />


                        </div>
                    </div>
                )}

                    {activeTab === "transfer" && (
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-labell">
                                    Select Employee<span className="astrisk">*</span>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <Select
                                    options={helpdeskperson} // ✅ dynamic employee list
                                    value={formData.employees}
                                    onChange={(selected) =>
                                        setFormData((prev) => ({ ...prev, employees: selected }))
                                    }
                                    styles={{
                                        ...reactSelectStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    placeholder="Select Employee..."
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    tabSelectsValue={true}
                                /></div>
                        </div>
                    )}



                    {selectedTxnStats?.payment_details?.length > 0 && (
                        <div style={{ marginBottom: "20px" }}>
                            <table className="table table-bordered mt-3 trasferPaymentTable">
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.length === selectedTxnStats.payment_details.length}
                                                onChange={handleSelectAll}
                                            />
                                        </th>
                                        <th>Receiving ID</th>
                                        <th>Cheque Number</th>
                                        <th>IFSC code</th>
                                        <th>Bank Name</th>
                                        <th>Student</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                        {activeTab === "deposit" && selectedRows.length > 0 && <th>Action<span className="astrisk">*</span></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedTxnStats.payment_details.map((dd, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(dd.transaction_id)}
                                                    onChange={() => handleRowSelect(dd.transaction_id)}
                                                />
                                            </td>
                                            <td>{dd.transaction_id}</td>
                                            <td>{dd.cheque_number}</td>
                                            <td>{dd.ifsc_code}</td>
                                            <td>{dd.bank_name}</td>
                                            <td>{dd.student_name}</td>
                                            <td style={{ textAlign: "right" }}>₹{dd.amount.toFixed(2)}</td>

                                            {activeTab === "deposit" && selectedRows.includes(dd.transaction_id) && (
                                                <td>

                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form-control"
                                                        onChange={e =>
                                                            handleChange(
                                                                cleanedTxnType === "cheque" ? "cheque" : "dd", // use cleanedTxnType here
                                                                dd.transaction_id,
                                                                e.target.files[0]
                                                            )
                                                        }
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {/* 🆕 Remark field for both tabs */}
                    <div className="row mt-3">
                        <div className="col-md-4">
                            <label className="form-labell">Remark</label>
                        </div>
                        <div className="col-md-6">
                            <textarea
                                className="form-control fm-modal"
                                placeholder="Enter remark (optional)"
                                value={formData.remark}
                                onChange={(e) => handleChange("remark", null, e.target.value)}
                                rows={2}
                            />
                        </div>
                    </div>





                </>
            );
        }

        if (txnType.includes("demand draft")) {

            return (
                <>  {/* 🟣 Form Fields */}
                    {activeTab === "deposit" && (
                        <>
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="form-labell">
                                        Select Bank Account<span className="astrisk">*</span>
                                    </label>
                                </div>
                                <div className="col-md-6">
                                    <Select
                                        options={bankOptions}
                                        value={bankOptions.find((opt) => opt.value === formData.bankAccount)}
                                        onChange={(selected) =>
                                            setFormData((prev) => ({ ...prev, bankAccount: selected.value }))
                                        }
                                        placeholder="Choose Bank Account..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 })
                                        }}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        tabSelectsValue={true}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                {/* <div className="col-md-4">
                                    <label className="form-labell">
                                        Select Bank Account<span className="astrisk">*</span>
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="form-control fm-modal mt-2"
                                        onChange={(e) => handleChange("dd", "image", e.target.files[0])}
                                    /></div> */}
                            </div>
                        </>
                    )}
                    {activeTab === "transfer" && (

                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-labell">
                                    Select Employee<span className="astrisk">*</span>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <Select
                                    options={helpdeskperson} // ✅ dynamic employee list
                                    value={formData.employees}
                                    onChange={(selected) =>
                                        setFormData((prev) => ({ ...prev, employees: selected }))
                                    }
                                    styles={{
                                        ...reactSelectStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    placeholder="Select Employee..."
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    tabSelectsValue={true}
                                />
                            </div>

                        </div>

                    )}


                    {selectedTxnStats?.payment_details?.length > 0 && (
                        <div style={{ marginBottom: "20px" }}>
                            <table className="table table-bordered mt-3 trasferPaymentTable">
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                checked={
                                                    selectedRows.length === selectedTxnStats.payment_details.length
                                                }
                                                onChange={handleSelectAll}
                                            />
                                        </th>
                                        <th>Receiving ID</th>
                                        <th>Date of Issuing</th>

                                        <th>DD Number</th>
                                        <th>Issuing Branch</th>
                                        <th>Student</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                        {activeTab === "deposit" && selectedRows.length > 0 && <th>Action<span className="astrisk">*</span></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedTxnStats.payment_details.map((dd, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(dd.transaction_id)}
                                                    onChange={() => handleRowSelect(dd.transaction_id)}
                                                />
                                            </td>
                                            <td>{dd.transaction_id}</td>
                                            <td>{dd.date_of_issuing}</td>
                                            <td>{dd.dd_number}</td>
                                            <td>{dd.issuing_branch}</td>
                                            <td>{dd.student_name}</td>
                                            <td style={{ textAlign: "right" }}>₹{dd.amount.toFixed(2)}</td>
                                            {activeTab === "deposit" && selectedRows.includes(dd.transaction_id) && (
                                                <td>

                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form-control"
                                                        onChange={e =>
                                                            handleChange(
                                                                cleanedTxnType === "cheque" ? "cheque" : "dd", // use cleanedTxnType here
                                                                dd.transaction_id,
                                                                e.target.files[0]
                                                            )
                                                        }
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* 🆕 Remark field for both tabs */}
                    <div className="row mt-3">
                        <div className="col-md-4">
                            <label className="form-labell">Remark </label>
                        </div>
                        <div className="col-md-6">
                            <textarea
                                className="form-control fm-modal"
                                placeholder="Enter remark (optional)"
                                value={formData.remark}
                                onChange={(e) => handleChange("remark", null, e.target.value)}
                                rows={2}
                            />
                        </div>
                    </div>





                </>
            );
        }


        return null;
    };

    const trapRef = useFocusTrap(isOpen);


    const isFormValid = () => {
        // 👉 Cash Deposit
        if (activeTab === "deposit" && txnType.includes("Cash")) {
            return (
                formData.bankAccount &&
                selectedTxnStats?.numbers > 0 &&
                formData.dd?.image instanceof File // ✅ require deposit slip
            );
        }

        // 👉 Cash Transfer
        if (activeTab === "transfer" && txnType.includes("Cash")) {
            return formData.employees?.value && selectedTxnStats?.numbers > 0;
        }

        // 👉 Cheque / DD Deposit
        if (
            activeTab === "deposit" &&
            (txnType.toLowerCase().includes("cheque") ||
                txnType.toLowerCase().includes("demand draft"))
        ) {
            const selectedTransactions =
                selectedTxnStats?.payment_details?.filter((dd) =>
                    selectedRows.includes(dd.transaction_id)
                ) || [];

            // must have bank account, at least one transaction, and each transaction must have a file
            const allFilesAttached = selectedTransactions.every((dd) => {
                const fileMap = txnType.toLowerCase().includes("cheque")
                    ? formData.cheque
                    : formData.dd;
                return fileMap?.[dd.transaction_id] instanceof File;
            });

            return formData.bankAccount && selectedTransactions.length > 0 && allFilesAttached;
        }

        // 👉 Cheque / DD Transfer
        if (
            activeTab === "transfer" &&
            (txnType.includes("cheque") || txnType.includes("demand draft"))
        ) {
            return formData.employees?.value && selectedRows.length > 0;
        }

        return false;
    };


    if (!isOpen) return null;

    return (
        <>
            <div className="modal-overlay">
                <div
                    className="modal-content"
                    style={{
                        position: "relative",
                        width: "70%",
                        minHeight: "450px",   // ✅ ensures modal never gets too small
                        maxHeight: "90vh",    // ✅ ensures modal never exceeds viewport height
                        display: "flex",
                        flexDirection: "column",
                        overflow: "auto",     // ✅ allows scrolling when content exceeds maxHeight
                    }}

                    ref={trapRef}
                >
                    {/* Header */}
                    <div
                        className="modal-header-content"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                        }}
                    >
                        <h2 className="text-primary">
                            {getRemittanceTitle(selectedTxnStats.type)} Remittance
                        </h2>
                        <div
                            style={{
                                textAlign: "right",
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                            }}
                        >
                            {/* Show count only if not Cash */}
                            <div>
                                {selectedTxnStats?.type !== "Cash In Hands" && (
                                    <span
                                        style={{
                                            fontWeight: "600",
                                            fontSize: "15px",
                                            display: "block",
                                        }}
                                    >
                                        No. of {getRemittanceTitle(selectedTxnStats?.type)} :{" "}
                                        {selectedTxnStats?.numbers || 0}
                                    </span>
                                )}

                                <span
                                    style={{
                                        fontWeight: "600",
                                        fontSize: "15px",
                                        display: "block",
                                    }}
                                >
                                    Total Amount : ₹
                                    {selectedTxnStats?.type === "Cash In Hands"
                                        ? selectedTxnStats?.numbers?.toFixed(2) || "0.00"
                                        : selectedTxnStats?.transactios?.toFixed(2) || "0.00"}
                                </span>
                            </div>
                            <button className="close-btn" onClick={handleClose}>
                                <img src={close} alt="close" />
                            </button>
                        </div>
                    </div>

                    {/* Tabs */}
                    <ul className="tabs" role="tablist">
                        <li
                            role="tab"
                            aria-selected={activeTab === "deposit"}
                            tabIndex={0}   // always tabbable
                            className={activeTab === "deposit" ? "tab active" : "tab"}
                            onClick={() => setActiveTab("deposit")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") setActiveTab("deposit");
                                if (e.key === "ArrowRight") setActiveTab("transfer");
                            }}
                        >
                            Deposit
                        </li>
                        <li
                            role="tab"
                            aria-selected={activeTab === "transfer"}
                            tabIndex={0}   // always tabbable
                            className={activeTab === "transfer" ? "tab active" : "tab"}
                            onClick={() => setActiveTab("transfer")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") setActiveTab("transfer");
                                if (e.key === "ArrowLeft") setActiveTab("deposit");
                            }}
                        >
                            Transfer
                        </li>
                    </ul>



                    {/* Body with scroll */}
                    <div
                        className="modal-body"
                        style={{
                            flex: 1,
                            overflowY: "auto", // allows scrolling only body
                            paddingBottom: "70px", // space for footer
                        }}
                    >
                        {renderFields()}
                    </div>

                    {/* Footer fixed */}
                    <div
                        className="modal-footer"
                        style={{
                            position: "sticky",
                            bottom: 0,
                            background: "#fff",
                            padding: "10px 20px",
                            textAlign: "right",
                            borderTop: "1px solid #eee",
                        }}
                    >
                        <button
                            className="add-btn"
                            onClick={handleSubmit}
                            // disabled={!isFormValid() || loading}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "10px 20px",
                                cursor: !isFormValid() || loading ? "not-allowed" : "pointer",
                                backgroundColor: !isFormValid() || loading ? "#d3d3d3" : "#7F56DA",
                                color: "#fff",
                                border: "none",
                                borderRadius: "6px",
                            }}
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                                "Remit"
                            )}
                        </button>


                    </div>
                </div>
            </div>



            <OtpModal
                title="Verify Remitance"
                heading={`Please Enter 6 digit OTP to verify the remittance sent to ${transferSubmitResponse?.selectedEmployee || "selected employee"
                    }`}
                isOpen={otpModal}
                onConfirm={handleConfirmOtp}
                onCancel={handleCancelOtp}
                studentResponse={transferSubmitResponse}
                onResend={handlesResendOtpToAssignedPerson}
            // reverifyDiscountOtp={helpdeskperson}
            />
        </>
    );
};
